import './App.css';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import routes from './Routes/Routes';
import AppLayout from './Layout/AppLayout';
import ProtectedRoute from './Routes/ProtectedRoute';
import ScrollToTop from './Components/ScrollToTop';
import PageNotFound from './Pages/PageNotFound';

function App() {
  const mRoutes = [
    {
      element: (
        <ProtectedRoute>
          <ScrollToTop />
          <AppLayout />
        </ProtectedRoute>
      ),
      errorElement: <PageNotFound />,
      children: [
        ...routes,
        { path: '*', element: <PageNotFound /> },
      ],
    },
  ];

  const router = createBrowserRouter(mRoutes);

  return <RouterProvider router={router} />
}

export default App;